import { render } from "./DepositWebsiteLesotho.vue?vue&type=template&id=0a59f6cc&scoped=true"
import script from "./DepositWebsiteLesotho.vue?vue&type=script&lang=js"
export * from "./DepositWebsiteLesotho.vue?vue&type=script&lang=js"

import "./DepositWebsiteLesotho.vue?vue&type=style&index=0&id=0a59f6cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a59f6cc"]])

export default __exports__